export enum InvitationStatus {
  Sent = "Sent",
  Accepted = "Accepted",
}
